import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const serviceIcons: Record<string, string> = {
  'ri-vidicon-line': 'ri-vidicon-line',
  'ri-share-line': 'ri-share-line',
  'ri-movie-line': 'ri-movie-line',
  'ri-global-line': 'ri-global-line',
  'ri-smartphone-line': 'ri-smartphone-line',
};

export default function Services() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            核心服务
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            全方位内容营销解决方案
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            覆盖内容创作全链路，从创意策划到执行落地，一站式满足品牌内容营销需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-6 md:p-7 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:translate-y-[-2px]"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${serviceIcons[cat.icon] || 'ri-file-line'} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                {cat.name}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center gap-1 text-primary-600 text-sm font-medium">
                <span>了解更多</span>
                <i className="ri-arrow-right-line text-xs transition-transform duration-200 group-hover:translate-x-0.5"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}